/** Yasuo canvas painter stub. */
export class YasuoPainter {
  static draw(ctx, entity, teamColor) {
    ctx.fillStyle = teamColor || '#38bdf8';
    ctx.beginPath();
    ctx.arc(entity.x, entity.y, entity.radius || 20, 0, Math.PI * 2);
    ctx.fill();
  }
}
